import { render, staticRenderFns } from "./DevicePreviewBox.vue?vue&type=template&id=317e7400&scoped=true&"
import script from "./DevicePreviewBox.vue?vue&type=script&lang=ts&"
export * from "./DevicePreviewBox.vue?vue&type=script&lang=ts&"
import style0 from "./DevicePreviewBox.vue?vue&type=style&index=0&id=317e7400&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e7400",
  null
  
)

export default component.exports